import React from 'react';
import { WeatherIconType } from '../utils/weatherUtils';
import {
  BlizzardIcon,
  ClearDayIcon,
  ClearNightIcon,
  FogIcon,
  HazeIcon,
  HeavyRainIcon,
  LightRainIcon,
  LightSnowIcon,
  MostlyCloudyIcon,
  OvercastIcon,
  PartlyCloudyDayIcon,
  PartlyCloudyNightIcon,
  RainMoonIcon,
  RainSunIcon,
  ShowersIcon,
  SleetIcon,
  SnowShowersIcon,
  SunriseIcon,
  SunsetIcon,
  ThunderstormIcon,
  ThunderstormWithRainIcon,
  WindyIcon,
} from '../icons';
import styles from './WeatherIcon.module.scss';

interface WeatherIconProps {
  type: WeatherIconType;
  size?: 'small' | 'large';
}

const iconMap: Record<WeatherIconType, React.FC<{ className?: string }>> = {
  blizzard: BlizzardIcon,
  'clear-day': ClearDayIcon,
  'clear-night': ClearNightIcon,
  fog: FogIcon,
  haze: HazeIcon,
  'heavy-rain': HeavyRainIcon,
  'light-rain': LightRainIcon,
  'light-snow': LightSnowIcon,
  'mostly-cloudy': MostlyCloudyIcon,
  overcast: OvercastIcon,
  'partly-cloudy-day': PartlyCloudyDayIcon,
  'partly-cloudy-night': PartlyCloudyNightIcon,
  'rain-moon': RainMoonIcon,
  'rain-sun': RainSunIcon,
  showers: ShowersIcon,
  sleet: SleetIcon,
  'snow-showers': SnowShowersIcon,
  sunrise: SunriseIcon,
  sunset: SunsetIcon,
  'thunderstorm-with-rain': ThunderstormWithRainIcon,
  thunderstorm: ThunderstormIcon,
  windy: WindyIcon,
};

function WeatherIcon({ type, size = 'small' }: WeatherIconProps) {
  const sizeClass = size === 'large' ? styles.large : styles.small;
  const IconComponent = iconMap[type];

  if (!IconComponent) {
    return null;
  }

  return (
    <div className={`${styles.weatherIcon} ${sizeClass}`}>
      <IconComponent className={styles.icon} />
    </div>
  );
}

export default React.memo(WeatherIcon);
